import { SectionList, type SectionListProps } from '~/shared/section/section-list/SectionList';
import { useFullOrder } from './orders/FullOrderContext';

export function OrderItems(props: SectionListProps) {
	const { canEdit } = useFullOrder();
	if (canEdit) {
		return <SectionList {...props} canEdit />;
	} else if (props.items.length === 0) {
		return null;
	}
	return <SectionList {...props} />;
}
